import { render, staticRenderFns } from "./TutorialSidebar.vue?vue&type=template&id=55940b8c&scoped=true&"
import script from "./TutorialSidebar.vue?vue&type=script&lang=js&"
export * from "./TutorialSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TutorialSidebar.vue?vue&type=style&index=0&id=55940b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55940b8c",
  null
  
)

export default component.exports